export default __webpack_public_path__ + "static/media/image-previousExam-2000x3000-png.2758263c.png";